import UserIcon from "@mui/icons-material/Person";
import PencilIcon from "@mui/icons-material/Edit";
import ChevronUpIcon from "@mui/icons-material/ExpandLess";
import ChevronDownIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import { artistImageUrl } from "../api/artistReview";
import ReviewIconButton from "./ReviewIconButton";
import ArtistNameEditor from "./ArtistNameEditor";
import VariationReviewRow from "./VariationReviewRow";
export default function ArtistReviewCard({
  artist,
  expanded,
  onToggle,
  review,
  disabled,
}) {
  const [imageFailed, setImageFailed] = React.useState(false);
  const [editing, setEditing] = React.useState(false);
  const cardRef = React.useRef(null);
  const wasEditing = React.useRef(false);
  React.useLayoutEffect(() => {
    if (wasEditing.current && !editing)
      cardRef.current?.querySelector("[data-edit-name]")?.focus();
    wasEditing.current = editing;
  }, [editing]);
  const listId = `artist-variations-${artist.id}`;
  const renameKey = `artist:${artist.id}`;
  const closeEditor = () => {
    setEditing(false);
  };
  return (
    <article
      className="artist-review-card"
      ref={cardRef}
      aria-labelledby={`review-artist-${artist.id}`}
    >
      <div className="artist-review-header">
        {imageFailed ? (
          <span
            className="review-avatar"
            role="img"
            aria-label="Artist image unavailable"
          >
            <UserIcon className="icon" />
          </span>
        ) : (
          <img
            src={artistImageUrl(artist.id)}
            alt={artist.name}
            width="72"
            height="72"
            loading="lazy"
            onError={() => setImageFailed(true)}
          />
        )}
        <div className="artist-review-name">
          <h2 id={`review-artist-${artist.id}`}>{artist.name}</h2>
          {review.filter === "unreviewed" && (
            <small>{artist.name_variations.length} unreviewed</small>
          )}
        </div>
        <div className="review-actions">
          <ReviewIconButton
            label={`Edit primary name for ${artist.name}`}
            icon={PencilIcon}
            data-edit-name
            disabled={disabled || editing}
            onClick={() => setEditing(true)}
          />
          <ReviewIconButton
            label={`${expanded ? "Collapse" : "Expand"} variations for ${artist.name}`}
            icon={expanded ? ChevronUpIcon : ChevronDownIcon}
            onClick={onToggle}
            aria-expanded={expanded}
            aria-controls={listId}
            data-card-disclosure
          />
        </div>
      </div>
      {editing && (
        <ArtistNameEditor
          artist={artist}
          pending={!!review.pending[renameKey]}
          disabled={disabled}
          error={review.rowErrors[renameKey]}
          onSave={(name) => review.rename(artist.id, name)}
          onCancel={closeEditor}
        />
      )}
      <ul id={listId} className="artist-variations" hidden={!expanded}>
        {artist.name_variations.map((variation) => {
          const key = `variation:${variation.id}`;
          return (
            <VariationReviewRow
              key={variation.id}
              variation={variation}
              filter={review.filter}
              disabled={disabled || editing}
              pending={!!review.pending[key]}
              error={review.rowErrors[key]}
              onDecision={(decision) =>
                review.decide(artist.id, variation.id, decision)
              }
            />
          );
        })}
      </ul>
    </article>
  );
}
